<template>
    <div>
        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            loader="dots"
            :is-full-page="fullPage"
            :height="height"
            :width="width"
            background-color="#6b6969"
        ></loading>
        <div class="login-page">
            <div class="login-logo">
                <div><img src="../../../public/assets/img/gtl_white.png" alt="" style="width: 100px;"
                          class="img-fluid mb-3"></div>
                <router-link to="/" class="text-light"><b>Company Registration</b></router-link>
            </div>
            <div style="width: 360px;">
                <div class="card" style="margin-top: 0px">
                    <div class="card-body login-card-body">
                        <router-link to="/">
                            <div class="login-box-msg"><i class="fas fa-home"/> Go to Home</div>
                        </router-link>
                        <p class="login-box-msg">Sign in to start your session</p>
                        <form @submit.prevent="login">
                            <label for="company_name">Company Name</label>
                            <div class="input-group mb-3">

                                <input type="text" placeholder="Company Name" id="company_name" required
                                       class="form-control"
                                       v-model="data.company_name"/>
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-envelope"/>
                                    </div>
                                </div>
                            </div>
                            <label for="company_name">Company Email</label>

                            <div class="input-group mb-3">
                                <input type="email" placeholder="email" id="company_email" required class="form-control"
                                       v-model="data.email"/>
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-envelope"/>
                                    </div>
                                </div>
                            </div>
                            <label for="company_name">Password</label>
                            <div class="input-group mb-3">
                                <input type="password" placeholder="password" required v-model="data.password"
                                       class="form-control"/>
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-lock"/>
                                    </div>
                                </div>
                            </div>
                            <label for="company_name">Confirm Password</label>
                            <div class="input-group mb-3">
                                <input type="password" placeholder="password" required
                                       v-model="data.confirm_password"
                                       class="form-control"/>
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-lock"/>
                                    </div>
                                </div>
                            </div>
                            <p><router-link to="/login">Already have an account? Login</router-link> </p>

                            <div class="row">
                                <div class="col-md-6 offset-md-3">
                                    <button type="submit" class="btn btn-primary btn-block">Register</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    /* eslint-disable */
    import $ from 'jquery';
    import Swal from "sweetalert2";
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        name: "Register",
        data() {
            return {
                isLoading: false,
                fullPage: true,
                height: 128,
                width: 128,
                data: {
                    company_name:'',
                    email: '',
                    password: '',
                    confirm_password: ''
                },
                passwordFieldType: "password"

            };
        },
        components: {
            Sidebar: () => import('@/components/Sidebar'),
            Topnav: () => import('@/components/Topnav'),
            Loading: () => import('vue-loading-overlay'),
        },
        methods: {
            login() {
                if (this.data.password !== this.data.confirm_password) {
                    Swal.fire({
                        title: "Error!",
                        text: 'Passwords do not match',
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                    return;
                }
                this.isLoading = true;
                this.$store
                    .dispatch("companyRegister", this.data)
                    .then(() => {
                        if (this.$store.state.redirectPathLink !== null) {
                            this.$router.push((this.$store.state.redirectPathLink.path.fullPath));
                        } else {
                            this.$router.push('/company/dashboard');
                        }
                    })
                    .catch((err) => {
                        console.clear();
                        if (!(((err.response || {}).data || {}).success)) {
                            console.log(err.response)
                            Swal.fire({
                                title: "Error!",
                                text: err.response.data.message,
                                icon: "error",
                                confirmButtonText: "OK"
                            });
                        } else {
                            Swal.fire({
                                title: "Error!",
                                text: "Error whiles processing information",
                                icon: "error",
                                confirmButtonText: "OK"
                            });
                        }

                    }).finally(() => {
                    this.isLoading = false;
                });
            },

        },
        created() {
            setTimeout(() => {
                $('.nav-router-link').removeClass('active')
                $('#hub').addClass('active')
            }, 500)
        }
    };
</script>

<style scoped src="../../../public/assets/css/intern-dashboard.css"></style>

<style scoped>
    .login-page {
        background-image: url('../../assets/company.jpeg');
        background-size: cover;
        background-position: center center;
    }
</style>
